import { Button, Icon } from "components/common"
import useManageExpandedRowIds from "hooks/useExpandedRowIds"
import React from "react"
import theme from "utils/themeVars"
import cx from "clsx"
const EditIconForEditTask = ({ onClick, item }) => {
  const [rowIds, updateRowIds, doesRowIdExist] = useManageExpandedRowIds()

  return (
    <Button
      size="small"
      type="link"
      outlined
      onClick={onClick}
      className={cx("showBtn p-0", doesRowIdExist(item?.id) && "showAlways")}
      icon={<Icon icon="MdEdit" size="1em" color={theme["gray700"]} />}
      style={{ "--btn-color": theme["gray-800"], "--btn-bg": "transparent", "--ant-control-height-sm" : "22px" }}
    />
  )
}

export default EditIconForEditTask
